import React from "react";
import InputNumberInc from "./InputNumberInc";
const FormLayout = () => {
	return (
		<article className="full-layout">
			<div className="container">
				<div className="row">
					<div className="justify-content-center">
						<div className="col-md-12">
							<div className="card cmn--card form--card">
								<div className="card-header px-4">
									<h5 className="card-title">Forms</h5>
									<a className="card-btn" href="/#">
										See More
									</a>
								</div>
								<div className="card-body">
									<form>
										<div className="form-group form--group">
											<input
												type="text"
												placeholder="Pool Name"
												className="form-control form--control"
											/>
										</div>
										<div className="form-group form--group">
											<label className="d-flex justify-content-between">
												<span>Token: VFT</span>
												<span>Balance : 5000</span>
											</label>
											<div class="input-group mb-3">
												<span class="input-group-text">
													<span>Staking Token Contract</span>
												</span>
												<input
													type="number"
													placeholder="0.00"
													className="form-control form--control"
												/>
											</div>
										</div>
										<div className="form-group form--group">
											<label className="d-flex justify-content-between">
												<span>Token: VFT</span>
												<span>Balance : 5000</span>
											</label>
											<div class="input-group mb-3">
												<span class="input-group-text">
													<span>Reward Token Contract</span>
												</span>
												<input
													type="number"
													placeholder="0.00"
													className="form-control form--control"
												/>
											</div>
										</div>
										<InputNumberInc text="APR" placeholder="0.00" />
										<InputNumberInc
											text="Initial reward pool"
											placeholder="0.00"
										/>
										<InputNumberInc
											text="Max Participants Per pool"
											placeholder="0.00"
										/>
										<div className="form-check form--check">
											<input
												id="accept"
												type="checkbox"
												className="form-check-input"
											/>
											<label
												htmlFor="accept"
												className="form-check-label"
											>
												Please accept our terms and condition to
												progress
											</label>
										</div>
										<div className="mt-4">
											<button
												type="submit"
												className="cmn--btn btn-full-width w-100"
												style={{
													fontSize: `20px`,
													fontWeight: `600`,
												}}
											>
												CREATE
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</article>
	);
};

export default FormLayout;
